import React, { useContext } from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import { PathContext } from "../../App";

function Footer() {
  const navigate = useNavigate()
  const {path, setPath} = useContext(PathContext)
  const handleClick = (link) =>{

    if(link === "/user-register"){
      setPath("nav")
    }
    navigate(link)
  }
  return (
    <div className="section-seven pb-2">
      <div className="container section-seven-logo-container">
        <img src="/img/section-seven-logo.svg" className="img-fluid footer-mobile-logo" alt="" />
      </div>
      <div className="container section-seven-buttons-container-1">
        <div onClick={()=>handleClick("/advertiser-register")} className="section-seven-button-1" role="button">
          <img src="/img/sec-seven-icon-1.svg" className="img-fluid" alt="" />
          <span>Become a Service Provider on DDH</span>
        </div>

        <div onClick={()=>handleClick("/user-register")} className="section-seven-button-1" role="button">
          <img src="/img/sec-seven-icon-2.svg" className="img-fluid" alt="" />
          <span>Become a DDH Client</span>
        </div>

        <div onClick={()=>handleClick("/agent-register")} className="section-seven-button-1" role="button">
          <img src="/img/sec-seven-icon-3.svg" className="img-fluid" alt="" />
          <span>Become a DDH Listing/Showing Agent</span>
        </div>
      </div>
      <div className="container section-seven-buttons-container-2">
        <div onClick={()=>handleClick("/tc-register")} className="section-seven-button-1" role="button">
          <img src="/img/sec-seven-icon-4.svg" className="img-fluid" alt="" />
          <span>Become a DDH Transaction Coordinator</span>
        </div>

        <div onClick={()=>handleClick("/la-register")} className="section-seven-button-1" role="button">
          <img src="/img/sec-seven-icon-5.svg" className="img-fluid" alt="" />
          <span>Become an LO Agent</span>
        </div>
      </div>
      <div className="container-fluid mx-0 section-seven-address-container">
        {/* <div className="section-seven-address-1">
          <img
            src="/img/sec-seven-address-1.svg"
            className="img-fluid"
            alt=""
          />
          <span>661-466-3975</span>
        </div> */}
        <div className="section-seven-address-1">
          <img
            src="/img/sec-seven-address-2.svg"
            className="img-fluid"
            alt=""
          />
          <a href="mailto:support@dealdirecthomes.com" style={{textDecoration: "none", color: "#d4bb98"}}>support@dealdirecthomes.com</a>
        </div>
        {/* <div className="section-seven-address-1">
          <img
            src="/img/sec-seven-address-3.svg"
            className="img-fluid"
            alt=""
          />
          <span>3510 Lowndes Hill Park Road, Los Angeles</span>
        </div> */}
      </div>
      <div className="container-fluid px-0 mx-0 section-seven-bottom-pattern-logo-container">
        <img
          src="/img/section-seven-bottom-pattern.svg"
          className="img-fluid w-100"
          alt=""
        />
      </div>
    </div>
  );
}

export default Footer;
